import { Outlet } from "react-router-dom";

/**
 * Wraps all /offers routes with a consistent visual accent (Offer Point theme).
 */
export function OffersLayout() {
  return (
    <div className="space-y-6">
      <div
        className="h-1.5 rounded-full bg-gradient-to-r from-rose-600 via-rose-400 to-amber-400 shadow-sm"
        aria-hidden
      />
      <Outlet />
    </div>
  );
}
